module.exports = __webpack_public_path__ + "img/video_icon03.dae8bd62.png";